import * as R from 'remeda'

/**
 * 配列内のtruthyな値のみをフィルタリングした新しい配列を返します。
 * よく似た挙動のfilterExists関数がありますが、そちらは存在する値だけがフィルタリングされます。
 *
 * @template T - 返す配列の値の型。
 * @param items - フィルタリング対象の配列。
 * @returns truthyな値のみを含む配列。
 */
export function compact<T>(
  items: (T | '' | 0 | false | null | undefined)[] | null | undefined,
): T[] {
  return R.filter(items ?? [], R.isTruthy)
}
